import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

interface Props {
  description: string
  isSoldOut: boolean
  icon: React.ReactElement
  onClick: VoidFunction
  title: string
  to: string
}
export const KioskCard = (props: Props) => {
  const { t } = useTranslation()

  const Component = props.isSoldOut ? 'button' : Link
  const [searchParams] = useSearchParams()

  return (
    <Component
      className="relative flex-1 overflow-hidden rounded-md border border-gray-200 bg-white p-4 shadow-md"
      disabled={props.isSoldOut}
      onClick={props.onClick}
      to={`${props.to}?${searchParams.toString()}`}
    >
      {props.isSoldOut ? (
        <div className="bg-red-600 absolute right-0 top-0 flex size-24 -translate-y-1/2 translate-x-1/2 rotate-45 items-end justify-center pb-1 text-xs font-bold uppercase text-white shadow-md">
          {t('chooseProduct.card.soldOut')}
        </div>
      ) : null}

      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex size-20 items-center justify-center rounded-circle bg-gray-50">
          {props.icon}
        </div>

        <div>
          <h4 className="font-bold">{props.title}</h4>
          <div className="mt-2 text-[.75rem]">{props.description}</div>
        </div>
      </div>
    </Component>
  )
}
